import React from "react";
import Menu from "../Component/Navigation/menu"

const catagories=()=>{
   
    return(
        <Menu/>
    )
}
export default catagories


// WEBPACK FOOTER //
// ./src/Container/Navigation.jsx